import styled from 'styled-components';
import theme from 'src/theme';
export interface IButtonProps {
    isSelected?: boolean;
    onClick?: (eventTypeId: number) => void;
}

export const PageContentWrapper = styled.div`
    height: 100%;
    padding: 0 5px 5px;
    display: flex;
    justify-content: space-between;

    @media print {
        height: auto;
        width: 100%;
        display: block;
        padding: 0;
    }
`;

export const LeftContentWrapper = styled.div`
    flex: 0 0 calc(22.5% - 5px);
    max-width: calc(22.5% - 5px);
    flex-grow: 0;
    height: 100%;
    box-shadow: #ccc 0 2px 6px 2px;
    @media print {
        display: none;
    }
`;

export const RightContentWrapper = styled.div`
    flex: 0 0 calc(77.5% - 5px);
    max-width: calc(77.5% - 5px);
    overflow: hidden;
    position: relative;
    height: 100%;
    box-shadow: #ccc 0 2px 6px 2px;

    @media print {
        width: 100%;
        max-width: 100%;
        box-shadow: none;
        height: auto;
        overflow: visible;
    }
`;

export const LeftTopWrapper = styled.div`
    display: flex;
    align-items: center;
    height: 60px;
    background: ${theme.legacyColors.headingPanelBgColor};
    color: ${theme.legacyColors.headingColor};
    border-bottom: 2px solid ${theme.legacyColors.headingColor};
    padding: 0.25rem;
    position: relative;
    @media print {
        display: none;
    }
`;

export const RightWrapper = styled.div`
    flex: 0 0 90%;
    max-width: 90%;
`;

export const HeadingWrapper = styled.div`
    background: ${theme.legacyColors.darkBlue};
    height: 50px;
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: center;
    h3 {
        font-size: 0.9rem;
        font-weight: 500;
        padding: 0;
        margin: 0 10px;
        color: ${theme.legacyColors.headingColor};
        p {
            margin: 0;
            font-size: 0.7rem;
        }
    }
    @media print {
        display: none;
    }
`;

export const LeftHeadingWrapper = styled.div`
    flex: 0 0 40%;
    max-width: 40%;
    display: flex;
    align-items: center;
`;

export const RightHeadingWrapper = styled.div`
    display: flex;
    flex: 0 0 60%;
    max-width: 60%;
    justify-content: flex-end;
    align-items: center;
`;

export const HeadingOuterWrapper = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    border-bottom: 1px solid #ddd;
`;

export const TitleOuterWrapper = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    h3 {
        font-size: 0.9rem;
        font-weight: 500;
        padding: 0;
        margin: 0 10px;
        p {
            margin: 0;
            font-size: 0.7rem;
        }
    }
`;

export const DeleteEventsWrapper = styled.div`
    display: flex;
    height: 40px;
    margin-top: 10px;
    h3 {
        font-size: 0.9rem;
        font-weight: 500;
        padding: 0;
        margin: 0 10px;
        p {
            margin: 0;
            font-size: 0.7rem;
        }
    }
`;

export const DeleteTextWrapper = styled.div`
    display: flex;
`;

export const DeleteButtonsWrapper = styled.div`
    display: flex;
`;

export const LeftBottomWrapper = styled.div`
    flex: 0 0 60%;
    border-right: 1px solid #ddd;
    height: 100%;
    overflow: hidden;
    display: flex;
    justify-content: space-between;
`;

export const RightBottomWrapper = styled.div`
    height: 100%;
`;

export const EventListFooter = styled.div`
    display: flex;
    height: 50px;
`;

export const LastUpdated = styled.div`
    font-size: 0.7rem;
    font-weight: 400;
    margin: 0 0 0 10px;
`;

export const Heading2 = styled.h2`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    font-size: 0.9rem;
    font-weight: 500;
    .lower-wrapper {
        font-size: 0.7rem;
        font-weight: 400;
    }
`;

export const ReportingContextWrapper = styled.nav`
    display: flex;
    align-items: center;
    h3 {
        font-size: 0.9rem;
        font-weight: 500;
        display: inline-block;
        color: ${theme.legacyColors.headingColor};
        padding-left: 10px;
    }

    h4 {
        font-size: 0.8rem;
        font-weight: 400;
        display: inline-block;
        margin: 0 0 0 10px;
        color: ${theme.legacyColors.headingColor};
        max-width: 600px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        span.separator {
            margin: 0 5px;
        }
    }
`;

export const DetailsCheckboxWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    padding: 3px 10px;
    margin: 0 6px 0 0;
`;

export const DetailsText = styled.div`
    font-size: 0.7rem;
    font-weight: 400;
`;

export const SmallUpdateInfoWrapper = styled.div`
    font-size: 0.7rem;
    font-weight: 400;
`;

export const UpdateInfoWrapper = styled.div`
    font-size: 0.6rem;
    font-weight: 400;
    display: grid;
    grid-template-columns: 75px 115px 155px;
    margin: 0 15px;
    padding: 7px 8px;
    width: 375px;

    @media print {
        display: none;
    }

    &.print {
        display: none;
        @media print {
            display: grid;
            grid-template-columns: 75px 200px 150px;
        }
    }

    .clock-icon,
    .profile-icon {
        margin: 0 5px 0 0;
        color: #04265a;
    }

    .clock-icon {
        margin: 0 5px 0 5px;
    }
    div {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
`;
